import { render, staticRenderFns } from "./Mouth14.vue?vue&type=template&id=53e304bc&"
import script from "./Mouth14.vue?vue&type=script&lang=js&"
export * from "./Mouth14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports